import styled from "styled-components";
import { space, color, typography, layout } from "styled-system";

const Text = styled.div`
  display: inline-block;
  line-height: 1.5;

  ${space};
  ${color};
  ${typography};
  ${layout};
`;

export default Text;
